import { getActivityList } from "@/api/common";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useWithdrawStore = defineStore("withdraw", () => {
  const withdrawList = ref([]);
  const selectedChannel = ref({
    name:'',
    channelType: ''
  });
  const withdrawInfo = ref({
    userName: '',
    phone: '',
    email: '',
    cpf: '',
    cnpj: '',
    cpfId: '',
    evpId: '',
    brazilId: '',
    bank: '',
  })

  const setWithdrawList = (list: any): void => {
    withdrawList.value = list;
  }
  const setSelectedWithdrawChannel = (item: any): void => {
    selectedChannel.value = item;
  }
  const setWithdrawInfo = (data: any): void => {
    withdrawInfo.value = data;
  }
  return {
    withdrawList,
    selectedChannel,
    withdrawInfo,
    setWithdrawList,
    setSelectedWithdrawChannel,
    setWithdrawInfo
  };
}, {
  persist: true,
});
